import { render, staticRenderFns } from "./aside-panel-user-notifications.vue?vue&type=template&id=f7793518&scoped=true"
import script from "./aside-panel-user-notifications.vue?vue&type=script&lang=js"
export * from "./aside-panel-user-notifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7793518",
  null
  
)

export default component.exports